import React from 'react';
import AppBar from '../../../commons/AppBar'
import ButtonsModules from '../../../commons/ButtonsModules';
import SiteMap  from '../../../commons/SiteMap';
import SpecificComponent from '../../../commons/SpecificComponent';
import { Grid } from '@material-ui/core';
import { TopButtons } from '../../../commons/TopButtons';
import FromServer from '../FromServer';
import BilantChartData from '../Components/BilantChartData';
import PreviziuniChartData from '../Components/PreviziuniChartData';
import IstoricIndicatoriFinanciari from '../IstoricIndicatoriFinanciari';


export default class IndiciBursieri extends SpecificComponent {
    constructor(props) {
      super(props);
       this.state = {
        possibleOutcome: null,
       topButtons:[{id:'cursurifinanciare', label:'Cursuri financiare', color:'#900DCB'},
       {id:'indicibursieri', label:'Indici bursieri', color:'#C8C779'},
      

       ],
        
        mapButtons:[{id:'financiarcontabil', label:'Inapoi Financiar', color:'#900DCB'},
        {id:'acf', label:'Analiza cash flow (ACF)', color:'#900DCB'},
        {id:'cursurisiindici', label:'Cursuri si indici bursieri', color:'#900DCB'},
    ]
}
    }

     componentDidMount(){
      
  
    }

    goBack = (id) =>{
        this.props.history.push(`/${id}`)
    }
   

   
     render() { 
       return (
          <div>
                <AppBar history={this.props.history} title={this.dictionary.appBar.drawer.financiar} />
             
                <ButtonsModules history={this.props.history}
                    scop={'Financiar'} />

        <div style={{textAlign:'left'}}>
            {this.state.mapButtons.map((b,idx)=>{
                return(
                    <SiteMap 
                        key={idx}
                        b={b}
                        buttonSelected={this.goBack} />
                        
                )
            })}
        </div>
        <h1 className='pm-title'>Cursuri financiare</h1>
       
           
            <IstoricIndicatoriFinanciari  startFrom={2} />
         </div>
        );
       }
}